import AXIOS from './axiosClient'

class ConfigService {
  loadConfiguration() {
    return AXIOS.get("/config")
  }

  loadPublicConfiguration() {
    return AXIOS.get("/config", {baseURL: "/api/public"})
  }

}


export default new ConfigService();
